import isEqual from 'lodash/isEqual'
import { useEffect, useRef, useState } from 'react'

// Sync reviewed server values without discarding edits in unrelated sections.
export function useOnboardingDraftState<T>(savedValue: T, draft?: unknown) {
  const [value, setValue] = useState(savedValue)
  const previousSaved = useRef({ savedValue, draft })
  useEffect(() => {
    if (!isEqual(previousSaved.current, { savedValue, draft })) {
      previousSaved.current = { savedValue, draft }
      setValue(savedValue)
    }
  }, [savedValue, draft])
  return [value, setValue] as const
}
